import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('giletau_cookie_consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('giletau_cookie_consent', 'all');
    localStorage.setItem('giletau_analytics_enabled', 'true');
    setShowBanner(false);
  };

  const handleAcceptNecessary = () => {
    localStorage.setItem('giletau_cookie_consent', 'necessary');
    localStorage.setItem('giletau_analytics_enabled', 'false');
    setShowBanner(false);
  };

  const handleCustomize = () => {
    setShowDetails(!showDetails);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center pointer-events-none">
      <div className="pointer-events-auto w-full max-w-5xl mx-4 mb-6 bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden">
        <div className="p-8">
          <div className="flex items-start gap-4 mb-6">
            <div className="w-12 h-12 bg-[#1a1a1a] rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-cookie-line text-white text-2xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="text-2xl font-bold text-[#1a1a1a] mb-3">
                Gestion des cookies
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Nous utilisons des cookies pour améliorer votre expérience de navigation et analyser l'utilisation de notre site. 
                Vous pouvez choisir d'accepter tous les cookies ou uniquement les cookies nécessaires au fonctionnement du site.
              </p>
              <Link 
                to="/politique-cookies" 
                className="text-sm text-[#1a1a1a] underline hover:no-underline cursor-pointer"
              >
                En savoir plus sur notre politique cookies
              </Link>
            </div>
          </div>

          {showDetails && (
            <div className="mb-6 p-6 bg-gray-50 rounded-xl space-y-4">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h4 className="font-bold text-[#1a1a1a] mb-2 flex items-center gap-2">
                    <i className="ri-shield-check-line text-green-600"></i>
                    Cookies nécessaires
                  </h4>
                  <p className="text-sm text-gray-600">
                    Ces cookies sont indispensables au bon fonctionnement du site. Ils ne peuvent pas être désactivés.
                  </p>
                </div>
                <div className="ml-4">
                  <div className="w-12 h-6 bg-green-600 rounded-full flex items-center justify-end px-1 cursor-not-allowed">
                    <div className="w-4 h-4 bg-white rounded-full"></div>
                  </div>
                </div>
              </div>

              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h4 className="font-bold text-[#1a1a1a] mb-2 flex items-center gap-2">
                    <i className="ri-bar-chart-line text-blue-600"></i>
                    Cookies analytiques
                  </h4>
                  <p className="text-sm text-gray-600">
                    Ces cookies nous aident à comprendre comment vous utilisez le site pour l'améliorer. Les données sont anonymisées.
                  </p>
                </div>
                <div className="ml-4">
                  <button
                    type="button"
                    className="w-12 h-6 bg-gray-300 rounded-full flex items-center px-1 cursor-pointer hover:bg-gray-400 transition-colors"
                    aria-label="Activer les cookies analytiques"
                  >
                    <div className="w-4 h-4 bg-white rounded-full"></div>
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={handleAcceptAll}
              className="flex-1 bg-[#1a1a1a] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#2a2a2a] transition-colors cursor-pointer whitespace-nowrap"
              type="button"
            >
              Tout accepter
            </button>
            <button
              onClick={handleAcceptNecessary}
              className="flex-1 bg-white text-[#1a1a1a] px-6 py-3 rounded-lg font-semibold border-2 border-[#1a1a1a] hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
              type="button"
            >
              Cookies nécessaires uniquement
            </button>
            <button
              onClick={handleCustomize}
              className="flex-1 bg-gray-100 text-[#1a1a1a] px-6 py-3 rounded-lg font-semibold hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
              type="button"
            >
              {showDetails ? 'Masquer les détails' : 'Personnaliser'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
